import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import CheckBox from '../../../../../../../componentes/checkbox/checkbox.component';
import WebapiCommon from '../../../../../../../app/common/util/webapi.common';

class CadastroTopografiaModal extends Component {
  constructor() {
    super();
    this.cadastrarNovaTopografia = this.cadastrarNovaTopografia.bind(this);
    this.state = {
      masculino: false,
      feminino: false,
      ambos: true,
    };
  }

  render() {
    const { show, toggle, value } = this.props;
    const { masculino, feminino, ambos } = this.state;
    return (
      <Modal centered isOpen={show} toggle={toggle}>
        <ModalHeader toggle={toggle}>Cadastrar nova Topografia</ModalHeader>
        <ModalBody>
          <Row>
            <Col>
              <FormGroup>
                <Label>Topografia:</Label>
                <Input disabled={true} value={value} />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col>
              <p style={{ fontSize: '0.8rem', fontWeight: 700 }}>
                Topografia aplicada ao sexo:
              </p>
            </Col>
          </Row>
          <Row>
            <Col>
              <FormGroup style={{ marginTop: '3px' }}>
                <CheckBox
                  label='Masculino'
                  name='masculino'
                  onChange={(e) => this.definirSexoAplicavel('masculino', e)}
                  checked={masculino}
                />
              </FormGroup>
            </Col>
            <Col>
              <FormGroup style={{ marginTop: '3px' }}>
                <CheckBox
                  label='Feminino'
                  name='feminino'
                  onChange={(e) => this.definirSexoAplicavel('feminino', e)}
                  checked={feminino}
                />
              </FormGroup>
            </Col>
            <Col>
              <FormGroup style={{ marginTop: '3px' }}>
                <CheckBox
                  label='Ambos'
                  name='ambos'
                  onChange={(e) => this.definirSexoAplicavel('ambos', e)}
                  checked={ambos}
                />
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color='secondary' onClick={toggle}>
            Cancela
          </Button>
          <Button color='primary' onClick={this.cadastrarNovaTopografia}>
            Confirmar
          </Button>{' '}
        </ModalFooter>
      </Modal>
    );
  }

  definirSexoAplicavel(name, ev) {
    let checked = ev.target.checked;
    this.setState({
      masculino: name === 'masculino' && checked,
      feminino: name === 'feminino' && checked,
      ambos: name === 'ambos' && checked,
    });
  }

  cadastrarNovaTopografia() {
    const {
      atualizarTopografia,
      toggle,
      selecionarTopografiaRecemCadastrada,
      value,
    } = this.props;
    let siglaSexo = this.state.masculino
      ? 'M'
      : this.state.feminino
      ? 'F'
      : 'A';
    WebapiCommon.cadastrarTopografia(value, siglaSexo).then(() => {
      WebapiCommon.getTopografias().then((topografias) => {
        atualizarTopografia(topografias);
        selecionarTopografiaRecemCadastrada(value);
        toggle();
      });
    });
  }
}

CadastroTopografiaModal.propTypes = {
  show: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
};

export default CadastroTopografiaModal;



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/material/tabs/receber/modal/topografia.cadastro.component.js